import { type StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import BaseEmbed from '../../../BaseEmbed';

export type ContainerProps = StructuredContentDocument<{
  id: string;
}>;

export default function Infogram({ props: { id } }: ContainerProps) {
  const src = `https://e.infogr.am/${id}?src=embed#async_embed`;

  return <BaseEmbed src={src} title="Infogram" />;
}
